import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID_TO_EDU",
  title: defineMessage({
    id: "fig.finance.aid.AID_TO_EDU.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.AID_TO_EDU.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.AID_TO_EDU.source",
    defaultMessage: ``,
  }),
};
